import { css, cx } from '@linaria/core';
import { theming } from 'styles/utils';
export const baseThumbnail = "omponents__Thumbnail__Thumbnail_styles_tsx-baseThumbnail-b107key4";
export const thumbnailSize = "omponents__Thumbnail__Thumbnail_styles_tsx-thumbnailSize-tyjsvi4";
export const defaultThumbnail = cx(thumbnailSize, baseThumbnail);

require("./Thumbnail.styles.linaria.module.css!=!../../node_modules/@linaria/webpack-loader/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js!./Thumbnail.styles.tsx");